"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackedStatistic = void 0;
var TrackedStatistic;
(function (TrackedStatistic) {
    TrackedStatistic["Kills"] = "kills";
    TrackedStatistic["KillsLair"] = "killslair";
    TrackedStatistic["Deaths"] = "deaths";
    TrackedStatistic["Strips"] = "strips";
    TrackedStatistic["Steps"] = "steps";
    TrackedStatistic["NPCsGreeted"] = "npcsgreeted";
    TrackedStatistic["RepeatableQuests"] = "repeatablequests";
    TrackedStatistic["DailyQuests"] = "dailyquests";
    TrackedStatistic["AchievementsEarned"] = "achievementsearned";
    TrackedStatistic["AchievementPoints"] = "achievementpoints";
    TrackedStatistic["AlchemyCrafts"] = "alchemycrafts";
    TrackedStatistic["MetalworkingCrafts"] = "metalworkingcrafts";
    TrackedStatistic["SpellforgingCrafts"] = "spellforgingcrafts";
    TrackedStatistic["GemcraftingCrafts"] = "gemcraftingcrafts";
    TrackedStatistic["WeavefabricatingCrafts"] = "weavefabricatingcrafts";
    TrackedStatistic["FoodmakingCrafts"] = "foodmakingcrafts";
})(TrackedStatistic || (exports.TrackedStatistic = TrackedStatistic = {}));
